module.exports = __webpack_public_path__ + "static/media/rockWall1.cb494d38.png";